import axios from "axios";
import { authenticatedApiConfig } from "./BaseApiService";
export class FullRecordService {
    constructor(authenticationProvider, environment) {
        this.authenticationProvider = authenticationProvider;
        this.environment = environment;
    }
    async downloadZip(patients, studyId) {
        const config = { ...(await authenticatedApiConfig(this.authenticationProvider)), responseType: "blob" };
        const response = await axios.post(`${this.environment.API_BASE_URL}/full-record/getzip?studyId=${studyId}`, patients, config);
        return response.data;
    }
    async downloadIdentifiedZip(patients, studyId) {
        const config = { ...(await authenticatedApiConfig(this.authenticationProvider)), responseType: "blob" };
        const response = await axios.post(`${this.environment.API_BASE_URL}/identified-full-record/getzip?studyId=${studyId}`, patients, config);
        return response.data;
    }
}
